import Vue from 'vue';
import Vuex from 'vuex';

/* We can disable import/no-cycle here because we know that
api only depends on the User module. */
// eslint-disable-next-line import/no-cycle
import Activity from '@/store/modules/activity';
// eslint-disable-next-line import/no-cycle
import ActivityDetails from '@/store/modules/activityDetails';
// eslint-disable-next-line import/no-cycle
import Configuration from '@/store/modules/configuration';
// eslint-disable-next-line import/no-cycle
import LandownerReport from '@/store/modules/landownerReport';
// eslint-disable-next-line import/no-cycle
import Notification from '@/store/modules/notification';
// eslint-disable-next-line import/no-cycle
import User from '@/store/modules/user';
// eslint-disable-next-line import/no-cycle
import Admin from '@/store/modules/admin';
// eslint-disable-next-line import/no-cycle
import optionModule from '@/store/modules/optionModule';
// eslint-disable-next-line import/no-cycle
import Map from '@/store/modules/map';
import LookupModules from '@/store/moduleConfig';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    Activity,
    ActivityDetails,
    Admin,
    Configuration,
    LandownerReport,
    Notification,
    User,
    Map,
  },
  getters: {
    isExtraSmall(state) {
      return state.isExtraSmall;
    },
  },
  mutations: {
    setIsExtraSmall(state, isSmall) {
      state.isExtraSmall = isSmall;
    },
  },
  state: {
    isExtraSmall: false,
  },
});

Object.keys(LookupModules)
  .forEach(key => store.registerModule(
    LookupModules[key].namespace,
    optionModule(LookupModules[key].url, LookupModules[key].idKey || 'id'),
  ));

export default store;
